//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getFullUrl } from "@nuskin/ns-common-lib";

import facebook from "../assets/facebook.svg";
import instagram from "../assets/instagram.svg";
import twitter from "../assets/twitter.svg";
import pinterest from "../assets/pinterest.svg";

export default {
  name: "NsSocialIcons",
  props: {
    /**
     * List of icons ([{socialIconLink, socialIconType, socialIconUrl}])
     */
    socialMediaList: {
      type: Array,
      default() {
        return [
          {
            socialIconType: "facebook",
            socialIconUrl: facebook,
            socialIconLink: "https://facebook.com/nuskin"
          },
          {
            socialIconType: "instagram",
            socialIconUrl: instagram,
            socialIconLink: "https://instagram.com/nuskin"
          },
          {
            socialIconType: "twitter",
            socialIconUrl: twitter,
            socialIconLink: "https://twitter.com/nuskin"
          },
          {
            socialIconType: "pinterest",
            socialIconUrl: pinterest,
            socialIconLink: "https://pinterest.com/nuskin"
          }
        ];
      },
      validator: value =>
        Array.isArray(value) &&
        value.every(item =>
          ["socialIconLink", "socialIconUrl"].every(
            prop => item[prop] && typeof item[prop] === "string"
          )
        )
    },
    /**
     * A title to display next to the icons
     */
    socialMediaHeaderText: {
      type: String,
      default: "CONNECT WITH NU SKIN"
    },
    /**
     * enable Minimal footer mode
     */
    minimal: {
      type: Boolean,
      default: false
    },
    /**
     * Stacks the title on top of the icons
     */
    stacked: {
      type: Boolean,
      default: null
    }
  },
  computed: {
    siteUrl() {
      return this.$NsAppService.siteUrl || "";
    },
    localStacked() {
      if (this.stacked === null) {
        return this.$mq !== "tablet";
      } else {
        return this.stacked;
      }
    }
  },
  methods: {
    getFullyQualifiedUrl(url) {
      return getFullUrl(this.siteUrl, url);
    }
  }
};
